import React from "react";
import Hero from './Hero';
import  Form  from "./Form";
import Global from './Global'

const Contact = () => {
    return (
<>
<Form/>
<Global/>
</>

    );
};

export default Contact;